module.exports = __webpack_public_path__ + "img/category_6.27c92f32.svg";